import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AccessToken } from './access-token';
import { environment } from '../../environments/environment'
import { AuthUtil } from './auth-util';
 
//This class will check for token availablity, if not redirects log in page.
@Injectable()
export class MdmGuard implements CanActivate {
 
    constructor(private router: Router) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        
        if(!environment.AZURE_LOGIN_NEEDED) {
            return true
        }
        
        let token: AccessToken = JSON.parse(localStorage.getItem('token'))
        let authUtil = new AuthUtil()
        let mdm_group = authUtil.getRoleClaim(token.access_token)
        if (token !== undefined && mdm_group !== undefined 
            && mdm_group.length > 0 && (mdm_group.includes(environment.AZURE_MDM_GROUP_ID) || mdm_group.includes(environment.AZURE_UK_DTC_POPGEN_LAB_ADMIN_CLAIM))) {
                return true
        } else {
            let answer = confirm('MDM needs admin login. Would you like to re-login as Admin ?')
            if(answer) {
                this.azureLogoutAndRouteToLogin()
            }
            
            return false
        }
 
        
    }

    azureLogoutAndRouteToLogin() {
        const util = new AuthUtil()
        util.logout()
        // this.router.navigate(['/'])
        //         .then(success => {
                   
        //         })
    }

    
}